const initPlanFlat = (parent: HTMLElement): void => {
    if (!parent) {
        console.warn(`Parent is ${parent}`);
    }

    const parentSelector = 'plan-flat';
    const selectors = {
        tabs      : `${parentSelector}__tabs`,
        item      : `${parentSelector}__item`,
        imgTabs   : `${parentSelector}__img-tabs`,
        planImage : `${parentSelector}__image`,
        popupSlide: `${parentSelector}__popup-slide`
    };

    const attrsNames = {
        contentVisible: 'content-visible',
        imageVisible  : 'image-visible',
        contentKey    : 'content-key',
        imageKey      : 'image-key'
    };

    const tabsEl = parent.querySelector(`.${selectors.tabs}`);
    const contentItemsEl = [].slice.call(parent.querySelectorAll(`.${selectors.item}`));
    const template = parent.querySelector('template') as HTMLTemplateElement;
    const slides = [].slice.call(template.content.querySelectorAll(`.${selectors.popupSlide}`));
    const imagesContent = [].slice.call(parent.querySelectorAll(`.${selectors.planImage}`));

    const setActiveSlide = (): void => {
        slides.forEach((slide: HTMLElement) => {
            imagesContent.forEach((imgContent: HTMLImageElement) => {
                if (imgContent.querySelector('img')?.src.includes(slide.querySelector('img')?.src ?? '')) {
                    if (imgContent.hasAttribute(attrsNames.imageVisible) &&
                        imgContent.parentElement?.parentElement?.hasAttribute(attrsNames.contentVisible)) {
                        slide.classList.add('swiper-slide-active');
                    } else {
                        slide.classList.remove('swiper-slide-active');
                    }
                }
            });
        });
    };

    if (tabsEl && contentItemsEl.length) {
        contentItemsEl.forEach((node: HTMLElement) => {
            const imagesTabsEl = node.querySelector(`.${selectors.imgTabs}`);
            const planImagesEl = [].slice.call(node.querySelectorAll(`.${selectors.planImage}`));

            if (imagesTabsEl && planImagesEl.length) {
                imagesTabsEl.addEventListener('change', (ev) => {
                    const selectedKey = (ev.target as HTMLInputElement).value;

                    planImagesEl.forEach((el: HTMLElement) => {
                        if (el.getAttribute(attrsNames.imageKey) === selectedKey) {
                            el.setAttribute(attrsNames.imageVisible, '');
                        } else {
                            el.removeAttribute(attrsNames.imageVisible);
                        }
                    });

                    setActiveSlide();
                });
            }
        });

        tabsEl.addEventListener('change', (ev) => {
            const selectedKey = (ev.target as HTMLInputElement).value;

            contentItemsEl.forEach((node: HTMLElement) => {
                if (node.getAttribute(attrsNames.contentKey) === selectedKey) {
                    node.setAttribute(attrsNames.contentVisible, '');
                } else {
                    node.removeAttribute(attrsNames.contentVisible);
                }
            });

            setActiveSlide();
        });
    }
};

export default initPlanFlat;
